module.exports = __webpack_public_path__ + "static/fullLogoPic-4923aee7a7463c64bdc47c6ce82d2296.png";